import { AxiosRequestHeaders } from 'axios';
import {
  KeyValueMap,
  EntryProps,
  PaginationQueryOptions,
  QueryParams,
} from '../../commonTypes';
import {
  CreateBoostRuleProps,
  RestEndpoint,
  UpdateBoostRuleProps,
} from './types';
import { AxiosInstance } from '../../commonTypes';
import * as raw from './raw';
import { DEFAULT_QUERY } from '../constants';

const BASE_URL = '/boost-rules';

export const get: RestEndpoint<'BoostRule', 'get'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T> | null>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
    params: {...DEFAULT_QUERY}
  });
};

export const getMany: RestEndpoint<'BoostRule', 'getMany'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: QueryParams<PaginationQueryOptions>,
  headers?: AxiosRequestHeaders
) => {
  return raw.get<EntryProps<T, true>>(http, `${BASE_URL}`, {
    headers: { ...headers },
    params: params.query,
  });
};

export const create: RestEndpoint<'BoostRule', 'create'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  rawData: CreateBoostRuleProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.post<EntryProps<T> | null>(http, `${BASE_URL}`, rawData, {
    headers: { ...headers },
  });
};

export const update: RestEndpoint<'BoostRule', 'update'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  rawData: UpdateBoostRuleProps,
  headers?: AxiosRequestHeaders
) => {
  return raw.put<EntryProps<T> | null>(
    http,
    `${BASE_URL}/${params.id}`,
    rawData,
    {
      headers: { ...headers },
    }
  );
};

export const del: RestEndpoint<'BoostRule', 'del'> = <
  T extends KeyValueMap = KeyValueMap
>(
  http: AxiosInstance,
  params: { id: string | number },
  headers?: AxiosRequestHeaders
) => {
  return raw.del<T>(http, `${BASE_URL}/${params.id}`, {
    headers: { ...headers },
  });
};
